import { render } from "./Edit.vue?vue&type=template&id=79ab87b7&scoped=true&ts=true"
import script from "./Edit.vue?vue&type=script&lang=ts"
export * from "./Edit.vue?vue&type=script&lang=ts"

import "./Edit.vue?vue&type=style&index=0&id=79ab87b7&lang=less&scoped=true"

import exportComponent from "D:\\officialWebsite\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79ab87b7"]])

export default __exports__